// REDUCER FOR JOB LIST
export function jobListdata(state = [], action) {
    switch (action.type) {
    case 'JOB LIST':
        console.log(action.data);
        return action.data;
    default:
        return state;
    }
}